"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_css_themr_1 = require("react-css-themr");
const LabelValueItem_1 = require("../LabelValueItem");
const List_1 = require("../List");
const DumpLabelValueList = ({ data, theme: defaultTheme = {}, }) => {
    if (!data) {
        return null;
    }
    const { items, theme: dataTheme = {} } = data;
    const theme = { ...defaultTheme, ...dataTheme };
    return (React.createElement(List_1.default, { entities: items, theme: theme.list, renderItem: (item) => (React.createElement(LabelValueItem_1.default, { data: item, theme: theme.item })) }));
};
exports.defaultLabelValueListTheme = {};
const LabelValueList = react_css_themr_1.themr('LabelValueList', {}, { composeTheme: 'softly' })(DumpLabelValueList);
exports.default = LabelValueList;
//# sourceMappingURL=index.js.map